// Cliente HTTP para el backend nuevo "Core" (NestJS + Prisma + PostgreSQL,
// backend/core). Reemplaza gradualmente la lógica que hoy vive en
// AppContext.js. El token JWT se guarda en localStorage para sobrevivir
// refrescos de página dentro de la misma sesión de login.

const BASE_URL = process.env.REACT_APP_CORE_API_URL || 'http://localhost:4000/api/core';
const TOKEN_KEY = 'alcor-core-token';

export const setAuthToken = (token) => {
  if (token) {
    window.localStorage.setItem(TOKEN_KEY, token);
  } else {
    window.localStorage.removeItem(TOKEN_KEY);
  }
};

export const getAuthToken = () => window.localStorage.getItem(TOKEN_KEY);

const request = async (path, options = {}) => {
  const token = getAuthToken();
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(`${BASE_URL}${path}`, { ...options, headers });

  if (!response.ok) {
    let message = `Error ${response.status}`;
    try {
      const body = await response.json();
      message = Array.isArray(body.message) ? body.message.join(', ') : body.message || message;
    } catch {
      // respuesta sin cuerpo JSON, mantenemos el mensaje genérico
    }
    throw new Error(message);
  }

  if (response.status === 204) return null;
  return response.json();
};

export const coreApi = {
  get: (path) => request(path),
  post: (path, body) => request(path, { method: 'POST', body: JSON.stringify(body ?? {}) }),
  patch: (path, body) => request(path, { method: 'PATCH', body: JSON.stringify(body ?? {}) }),
  delete: (path) => request(path, { method: 'DELETE' })
};

// Convierte los enums en MAYÚSCULAS del backend (UserRole, UserProfile) al
// formato snake_case en minúsculas que ya espera todo el frontend
// (navigation.js, helpers.js, etc.) — ambos vocabularios coinciden 1:1 salvo
// mayúsculas, así que un toLowerCase() alcanza.
export const mapCoreUser = (user) => ({
  id: user.id,
  name: user.name,
  email: user.email,
  role: user.role?.toLowerCase(),
  profile: user.profile?.toLowerCase(),
  avatar: user.avatar,
  department: user.department,
  allowedPages: user.allowedPages || null
});

export const coreAuth = {
  async login(email, password) {
    const result = await coreApi.post('/auth/login', { email, password });
    setAuthToken(result.accessToken);
    return { ...result, user: mapCoreUser(result.user) };
  },
  async logout() {
    try {
      await coreApi.post('/auth/logout');
    } finally {
      setAuthToken(null);
    }
  }
};
